import React from 'react';

import CircledDottedScheme8 from 'components/Schemes/CircledDottedScheme/8dots/CircledDottedScheme8';

const schemeData = [
  'Ensure compliance with\nhealthcare regulations',
  'Map out the workflows',
  'Create a\ncomprehensive\nroadmap',
  'Make improvements\nafter users’ feedback',
  'Train your personnel',
  'Migrate data accurately\nand securely',
  'Ensure data safety\nand security',
  'Involve dental specialists',
];

export const TipsScheme = () => (
  <CircledDottedScheme8
    items={schemeData}
    innerTitle="Successful EHR implementation"
    containerClass="dental-ehr-tips-scheme-block"
  />
);
